export default __webpack_public_path__ + "e9e2b4c1e00f00109484d28714ad7e8e.svg";